export type CalloutProperties = {
  id: SupportedMerchandisingTagType
  value: string
  skin: CalloutSkin
  variant?: CalloutVariant
}
export type CalloutSkin =
  | 'standard'
  | 'announcement'
  | 'foil'
  | 'holiday'
  | 'error'
  | 'new'
  | 'accent'
  | 'discount'
  | 'info'
  | 'warning'
  | 'success'
  | 'help'
  | 'promo'
  | null

export type CalloutVariant = 'standard' | 'overlay' | 'inverse'

export enum SupportedMerchandisingTagType {
  NEW_LOW_PRICE = 'NEW_LOW_PRICE',
  NEW = 'NEW',
  NEW_OPTIONS = 'NEW_OPTIONS'
}

export const hasValidTagType = (callout?: { tagType?: string }): boolean => {
  if (!callout?.tagType) {
    return true
  }
  return callout.tagType in SupportedMerchandisingTagType
}
export type CalloutEmphasis = 'standard' | 'low' | null

export type CalloutTagType = keyof typeof SupportedMerchandisingTagType
